<template>
  <v-row justify="center">
    <v-dialog :value="dialogWindowContact" persistent max-width="800px">
      <v-card >
        <v-card-title class="headline grey lighten-2" primary-title>
          Контакты победителя
          <v-spacer></v-spacer>
          <v-btn
            :loading="loading"
            :disabled="loading"
            icon
            @click.stop="UpdateContactsWindow"
          >
            <v-icon>loop</v-icon>
            {{ getDateNow() }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="CloseContactsWindow">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="padding: 10px 20px; ">
          <v-data-table
            :headers="headersPhones"
            dense
            :items="dessertsPhones"
            :items-per-page="5"
            class="elevation-1"
            v-if="dessertsPhones.length > 0"
          >
          <template v-slot:item.actual_date="{item}">
            {{moment(item.actual_date).format('DD.MM.YYYY')}}
          </template>
          <template v-slot:item.phone="{item}">
            <a :href="`tel://${item.phone}`" >{{item.phone}}</a>
          </template>

          </v-data-table>
          <div v-else>Не найдены телефоны по данной организации</div>
          <v-divider class="mt-2 mb-2"></v-divider>
<!-- hide-default-header -->
          <v-data-table
            :headers="headersEmails"
            dense
            :items="dessertsEmails"
            :items-per-page="5"
            class="elevation-1"
            v-if="dessertsEmails.length > 0"
          >
          <template v-slot:item.actual_date="{item}">
            {{moment(item.actual_date).format('DD.MM.YYYY')}}
          </template>
          <template v-slot:item.email="{item}">
            <a :href="`mailto:${item.email}`" >{{item.email}}</a>
          </template>
          </v-data-table>
          <div v-else>Не найдены телефоны по данной организации</div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import moment from 'moment'
export default {
  data() {
    return {
      moment,
      loading: false,
      headersPhones: [
        {
          text: "№ телефона",
          align: "start",
          sortable: false,
          value: "phone",
        },
        { text: "Ответственный", value: "contactPerson" },
        // { text: "Регион", value: "region" },
        { text: "Актуальная дата", value: "actual_date" },
      ],
      headersEmails: [
        {
          text: "Почта",
          align: "start",
          sortable: false,
          value: "email",
        },
        { text: "Ответственный", value: "contactPerson" },
        { text: "Актуальная дата", value: "actual_date" },
      ],
    };
  },
  methods: {
    getDateNow() {
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //Январь это  0!
      var yyyy = today.getFullYear();
      if (dd < 10) dd = "0" + dd;
      if (mm < 10) mm = "0" + mm;
      return dd + "." + mm + "." + yyyy;
    },
    UpdateContactsWindow() {
      this.loading = true;
      const updateINN ={
        inn: this.$store.getters.getCurrentWinnerID
      }
      this.$store
        .dispatch("updateWinnerContacts", updateINN)
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    CloseContactsWindow() {
      this.$store
        .dispatch("toggleWinnersContactWindow", false)
        .then(() => {})
        .catch((error) => {
          alert(error);
        });
    },
  },
  computed: {
    dessertsPhones() {
      return this.$store.getters.getPhonesWinners !== null ? this.$store.getters.getPhonesWinners : new Array();
    },
    dessertsEmails() {
      return this.$store.getters.getEmailsWinners !== null ? this.$store.getters.getEmailsWinners : new Array() ;
    },
    dialogWindowContact() {
      return this.$store.getters.getWinnersContactWindow;
    },
  },
  mounted() {
    this.setTitle("Контакты победителя");
  },
};
</script>

<style lang="scss">
#app {
  .theme--light.v-input:not(.v-input--is-disabled) input,
  .theme--light.v-input:not(.v-input--is-disabled) textarea {
    color: #217899;
  }
  h1 {
    font-size: 1.5rem;
  }
  .bluelink {
    color: #217899;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
  .v-data-table-header tr th {
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .v-data-table-header tr th {
    font-size: 14px;
  }
  .v-dialog table thead tr th {
    font-size: 14px;
  }
}
</style>
